import React from 'react';

import { ChevronRight } from '@xsolla/ui-icons';

import { SpaceBetweenBlock } from '../../../../styled';
import { LinkPAStyle } from '../../../ui';
import { TextWrapper } from './supportStyle';

type Props = {
  icon: React.ReactNode;
  text: string;
  link: string;
  dataTestId?: string;
};

const SupportLink = ({ icon, link, text, dataTestId }: Props): JSX.Element => {
  return (
    <LinkPAStyle href={link} target="_blank" rel="noreferrer" data-test-id={dataTestId}>
      <SpaceBetweenBlock>
        <TextWrapper>
          {icon} {text}
        </TextWrapper>
        <ChevronRight />
      </SpaceBetweenBlock>
    </LinkPAStyle>
  );
};

export default SupportLink;
